import React, { useCallback, useState } from 'react';

import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import styled, { css } from 'styled-components';
import { StyledButton } from 'styles/common';

import { StyledIcon } from 'constants/icons';

import ActionItemDisplay from './ActionItemDisplay';

const Container = styled.div`
  ${(props) =>
    !props.disabled &&
    css`
      pointer-events: all;
    `}
`;

const ActionItemsContainer = styled.div`
  padding-bottom: 1rem;
`;

const ShowCompletedButton = styled(StyledButton)`
  .MuiButton-label {
    color: ${(props) => props.theme.palette.text.secondary};
  }
`;

const CompletedActionItems = ({
  actionItems,
  onCheckToggle,
  onUpdate,
  actionItemsDispatch,
  disabled = false,
  filterEmpIds,
  isOneOnOne = false,
}) => {
  const [isCompletedViewVisible, setCompletedViewVisibility] = useState(false);
  const toggleCompletedViewVisibility = useCallback(() => {
    setCompletedViewVisibility((prev) => !prev);
  }, []);

  if (actionItems.length > 0) {
    return (
      <Container disabled={disabled}>
        <ShowCompletedButton
          startIcon={
            <StyledIcon color="textSecondary" size="tiny">
              {isCompletedViewVisible ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
            </StyledIcon>
          }
          variant="text"
          color="textSecondary"
          onClick={toggleCompletedViewVisibility}
          leftGutter={-0.5}
        >
          Show {isOneOnOne ? 'Completed Action Items' : 'Completed Initiatives'}
        </ShowCompletedButton>
        {isCompletedViewVisible && (
          <ActionItemsContainer className="completed-action-items-container">
            {actionItems.map((actionItem, index) => (
              <ActionItemDisplay
                key={`actionItem-${actionItem.uuid || `new${index}`}`}
                actionItem={actionItem}
                onCheckToggle={onCheckToggle}
                onUpdate={onUpdate}
                actionItemsDispatch={actionItemsDispatch}
                filterEmpIds={filterEmpIds}
              />
            ))}
          </ActionItemsContainer>
        )}
      </Container>
    );
  }

  return null;
};

export default CompletedActionItems;
